import { api } from "constants/RotasAPI";
import usePost from "hooks/usePost";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { ConfigurarGroupPayRequest } from "types/request/groupPay/ConfigurarGroupPayRequest";

type UseConfigurarGroupPayAsyncOptions = {
  successMessage?: string;
  errorMessage?: string;
  navigateTo?: string;
};

export const usePostConfigurarGroupPayAsync = (options: UseConfigurarGroupPayAsyncOptions = {}) => {
  const navigate = useNavigate();
  const { successMessage, errorMessage, navigateTo } = options;
  const onSuccess = () => {
    if (successMessage) toast.success(successMessage);
    if (navigateTo) navigate(navigateTo);
  };

  const onError = () => {
    if (errorMessage) toast.error(errorMessage);
  };

  return usePost<ConfigurarGroupPayRequest>({
    url: api.groupPay.postConfigurarGroupPayAsync,
    onSuccess,
    onError,
  });
};
